import { observer } from "mobx-react-lite"
import { useNavigate } from "react-router-dom"

import type { ChainConfig } from "@/domains/core"
import { Compound as Table } from "@/components/table"
import { ChevronRightIcon } from "@/domains/icons"
import { MinimalPoolStore } from "@/domains/minimal-pool"
import { AprColumn } from "@/domains/pools/components/apr-column"
import { PoolBalanceColumn } from "@/domains/pools/components/pool-balance-column"
import { PoolInfoColumn } from "@/domains/pools/components/pool-info-column"
import { PoolStakedColumn } from "@/domains/pools/components/pool-staked-column"
import { StakedColumn } from "@/domains/pools/components/staked-column"
import { TvlColumn } from "@/domains/pools/components/tvl-column"
import { WalletColumn } from "@/domains/pools/components/wallet-column"
import { ZapColumn } from "@/domains/pools/components/zap-column"
import { HandleZapClick } from "@/pages/liquidity"

import { ENABLE_ZAPS } from "../../constants"

export const LiquidityTableRow = observer(
  ({
    pool,
    chainConfig,
    isCompact,
    handleZapClick,
  }: {
    pool: MinimalPoolStore
    chainConfig: ChainConfig
    isCompact: boolean
    handleZapClick: HandleZapClick
  }) => {
    const navigate = useNavigate()
    return (
      <Table.Tr
        className="group cursor-pointer border-t"
        onClick={() => {
          navigate(`/liquidity/${pool.address.toString()}/add`)
        }}
      >
        <Table.Td className=" px-0 py-0 group-hover:bg-p400 sm:px-0">
          <div className="flex h-full w-full items-center justify-center">
            <ChevronRightIcon size={16} className="text-t300 group-hover:text-t200" />
          </div>
        </Table.Td>
        {ENABLE_ZAPS ? (
          <Table.Td className="px-0 pl-3  sm:px-0 sm:pl-3">
            <ZapColumn pool={pool} handleZapClick={handleZapClick} />
          </Table.Td>
        ) : null}
        <Table.Td className="px-0 pl-0 ">
          <PoolInfoColumn pool={pool} chainSlug={chainConfig.slug} />
        </Table.Td>
        <Table.Td className="">
          <AprColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right ">
          <TvlColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right ">
          <StakedColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right ">
          <WalletColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right ">
          <PoolBalanceColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
        <Table.Td className="text-right ">
          <PoolStakedColumn pool={pool} isCompact={isCompact} />
        </Table.Td>
      </Table.Tr>
    )
  },
)
